import { forwardRef, useId } from "react";
import { RadioProps } from "./Radio.types";
import { twMerge } from "tailwind-merge";
import { Theme } from "./Radio.theme";

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio({
  containerClassname,
  className,
  label,
  subtext,
  description,
  value,
  disabled,
  ...props
}: RadioProps, ref) {

  const id = useId();
  const sub = subtext ?? description;

  return (
    <div className={twMerge("flex mb-2", sub ? "items-start" : "items-center", disabled && "pointer-events-none opacity-60", containerClassname)}>
      <input
        ref={ref}
        className={twMerge(Theme.input, sub ? "mt-0.5" : "self-center", className)}
        value={value?.toString()}
        type="radio"
        id={id}
        disabled={disabled}
        aria-disabled={disabled || undefined}
        {...props}
      />
      {(!!label || !!sub) && (
        sub ? (
          <div className="flex flex-col ms-4">
            {label && (
              <label htmlFor={id} className={twMerge(Theme.label, "ms-0 cursor-pointer", disabled && Theme.labelDisabled)}>
                {label}
              </label>
            )}
            <span
              onClick={() => {
                if (!disabled) {
                  const input = document.getElementById(id) as HTMLInputElement | null;
                  input?.click();
                }
              }}
              className="text-xs text-gray-500 font-normal dark:text-gray-400 mt-0.5 cursor-pointer"
            >
              {sub}
            </span>
          </div>
        ) : (
          <label htmlFor={id} className={twMerge(Theme.label, disabled && Theme.labelDisabled)}>
            {label}
          </label>
        )
      )}
    </div>
  );
});
